const attach = (element) => {
    const list = element.querySelector('#list')
    const sliderWrapper = element.querySelector('#sliderWrapper')
    const slider = element.querySelector('#slider')
    const dropdown = element.querySelector('#dropdown')
    const select = element.querySelector('select')
    const form = element.querySelector('#frm-menu-switchCenterForm')

    let menuOpened = false

    const states = {
        scrollingHeight: 0,
        scrollerHeight: 0,
        scrollHelper: 0,
        heightCoefficient: 0.1
    }

    element.querySelector('select').addEventListener('mousedown', (disableNativeList) => {disableNativeList.preventDefault()})
    element.addEventListener('click', () => {handleToggle()})
    list.addEventListener('scroll', (event) => {handleScrollbar(event)})
    document.addEventListener('click', event => {
        const clickDropdown = dropdown.contains(event.target)
        const clickSelect = select.contains(event.target)

        if (!clickDropdown && !clickSelect && menuOpened) {
            dropdown.classList.remove('is-active')
            menuOpened = false
            event.preventDefault()
        } else {
            event.returnValue = true
        }
    })

    const fillNav = () => {
        const items = []
        let index = 0
        
        element.querySelectorAll('option').forEach(item => {
            items.push(item.textContent)
        })

        items.shift()
        items.sort()
        
        element.querySelectorAll('option').forEach(item => {
            if(item.getAttribute('value') > 0) {
                const li = document.createElement("li");
                const button = document.createElement("button");
                const newContent = document.createTextNode(items[index]);
                const currentDiv = document.getElementById("div1");
                button.appendChild(newContent);
                li.appendChild(button, currentDiv);
                list.insertBefore(li, currentDiv);
                index ++
            }
        })
    }

    const prepareItems = () => {
        element.querySelectorAll('button').forEach(item => {
            item.addEventListener('click', (event) => {handleLink(event, item)})
        })
    }

    const findActive = () => {
        element.querySelectorAll('option').forEach(option => {
            if(option.hasAttribute('selected')) {
                list.querySelectorAll('li').forEach(item => {
                    if(item.textContent === option.textContent) {
                        item.classList.add('is-selected')
                    }
                })
            }
        })
    }

    fillNav()
    prepareItems()
    findActive()

    const handleLink = (event, item) => {
        event.preventDefault()
        const centerName = item.textContent
        let selected = ''
        element.querySelectorAll('option').forEach(option => {
            if(option.textContent === item.textContent) {
                element.querySelectorAll('option').forEach(option => {
                    option.removeAttribute('selected')
                })
                option.setAttribute('selected', '')
                element.closest('form').submit()
                element.closest('.switch-center').classList.add('changing')
                select.focus()
                return
            }
        })
    }

    const handleToggle = () => {
        menuOpened = !menuOpened

        if(menuOpened) {
            dropdown.classList.add('is-active')
        } else {
            dropdown.classList.remove('is-active')
        }

        
    }

    const handleScrollbar = event => {
        states.scrollingHeight = list.scrollHeight - list.clientHeight
        const calculatedScroll = (100 / states.scrollingHeight) * list.scrollTop
        states.scrollHelper = (((100 / sliderWrapper.clientHeight) * slider.clientHeight) - 100) / -100
        slider.style.top = `${calculatedScroll}%`
        if(states.scrollingHeight === 0) {
            states.scrollerHeight = states.heightCoefficient * states.scrollingHeight
            sliderWrapper.style.display = "none"
        }
    }
}

document.querySelectorAll('#dropdown-scrollbar').forEach(attach)
